var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemixerAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99996 0.166016C6.7072 0.166016 7.38548 0.446967 7.88558 0.947064C8.38567 1.44716 8.66663 2.12544 8.66663 2.83268C8.66663 3.53993 8.38567 4.2182 7.88558 4.7183C7.38548 5.2184 6.7072 5.49935 5.99996 5.49935C5.29272 5.49935 4.61444 5.2184 4.11434 4.7183C3.61424 4.2182 3.33329 3.53993 3.33329 2.83268C3.33329 2.12544 3.61424 1.44716 4.11434 0.947064C4.61444 0.446967 5.29272 0.166016 5.99996 0.166016ZM5.99996 6.83268C8.94663 6.83268 11.3333 8.02602 11.3333 9.49935V10.8327H0.666626V9.49935C0.666626 8.02602 3.05329 6.83268 5.99996 6.83268Z",
    fill: "url(#paint0_linear_1654_4988)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1654_4988",
    x1: 0.666626,
    y1: 5.49935,
    x2: 11.3333,
    y2: 5.49935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52FAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#197AD0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemixerAccount);
export default __webpack_public_path__ + "static/media/remixer-account.52d3620c35ea5083cae089eba9216a21.svg";
export { ForwardRef as ReactComponent };